/* eslint-disable @next/next/no-img-element */
import { Radio, Select } from "antd";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Footer from "@buddieshr/components/footer";
import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import SlackMessagePreview from "@buddieshr/components/slackMessagePreview";
import styles from "@buddieshr/styles/Home_Billy.module.scss";
import ReadyForBilly from "@buddieshr/components/billy/readyForBilly";
import { CELEBRATION_TYPES, MESSAGE_TYPES } from "@buddieshr/utils/constants";
import Features from "@buddieshr/components/app/features";
import { PRODUCTS } from "@buddieshr/utils/constants-products";
import Image from "next/image";

export default function Preview({ refSource }) {
  const router = useRouter();
  const { t } = useTranslation();

  const app = PRODUCTS.find((c) => c.id === "Billy");

  const [names, setNames] = useState(null);
  const [messageType, setMessageType] = useState(MESSAGE_TYPES.v2);
  const [celebrationType, setCelebrationType] = useState(
    CELEBRATION_TYPES.BIRTHDAYS
  );
  const [loaded, setLoaded] = useState(false);

  const handleChange = (values) => {
    setNames(values);
  };

  const onChangeMessageType = ({ target: { value } }) => {
    setMessageType(value);
  };

  const onChangeMessageCelebrationType = ({ target: { value } }) => {
    setCelebrationType(value);
  };

  useEffect(() => {
    const namesFromURL = router.query.names
      ? router.query.names.split(";")
      : ["Ryan", "Sofia"];
    setNames(namesFromURL);
    setLoaded(true);
  }, [router.query]);

  return (
    <>
      <MetaHeader
        title={t("titlePreviewBilly")}
        description={t("descriptionPreviewBilly")}
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/${app.urlSlug || app.slug}/preview`}
        currentShare={`https://buddieshr.com/img/apps/${app.slug}/share_preview.png`}
        pageSlug={`${app.urlSlug || app.slug}/preview`}
        locale={router.locale}
      />
      <div className={styles.container}>
        <main
          className={styles.main}
          style={{ background: app.backgroundColor }}
        >
          <Header app={app} />
          <div className={styles.Preview_wrapper}>
            <div className={styles.Preview_inner}>
              <div className={styles.Preview_title}>
                <h1 className={styles.bold}>{t("previewTitle")}</h1>
                <div>{t("previewDescription")}</div>
              </div>
              <div className={styles.Preview_actions}>
                <div className={styles.Preview_action_item}>
                  <label style={{ marginRight: "8px", marginBottom: "12px" }}>
                    {t("names")}
                  </label>
                  {loaded && (
                    <div style={{ textAlign: "left" }}>
                      <div>
                        <Select
                          // prefix={<UserOutlined />}
                          mode="tags"
                          size="large"
                          style={{ minWidth: "300px", width: "300px" }}
                          placeholder="Enter 1 or multiple person's name"
                          defaultValue={names}
                          onChange={handleChange}
                          open={false}
                        />
                      </div>
                      <div className={styles.Field_hint}>{t("namesHint")}</div>
                    </div>
                  )}
                </div>
                <div
                  className={styles.Preview_action_item}
                  style={{ marginBottom: "12px" }}
                >
                  <label style={{ marginRight: "8px" }}>{t("style")}</label>
                  <Radio.Group
                    options={[
                      { label: t("formatted"), value: MESSAGE_TYPES.v2 },
                      { label: t("classic"), value: MESSAGE_TYPES.v1 },
                    ]}
                    onChange={onChangeMessageType}
                    value={messageType}
                    optionType="button"
                    buttonStyle="solid"
                    size="large"
                  />
                </div>
              </div>
              <div
                className={styles.Preview_action_item}
                style={{ marginBottom: "12px", justifyContent: "center" }}
              >
                <label style={{ marginRight: "8px" }}>
                  {t("celebrationType")}
                </label>
                <Radio.Group
                  options={[
                    {
                      label: t("birthdays"),
                      value: CELEBRATION_TYPES.BIRTHDAYS,
                    },
                    {
                      label: t("workAnniversaries"),
                      value: CELEBRATION_TYPES.WORK_ANNIVERSARIES,
                    },
                  ]}
                  onChange={onChangeMessageCelebrationType}
                  value={celebrationType}
                  optionType="button"
                  buttonStyle="solid"
                  size="large"
                />
              </div>
              <div>
                <SlackMessagePreview
                  app={app}
                  names={names}
                  version={messageType}
                  celebrationType={celebrationType}
                />
              </div>
            </div>
            <div className={styles.center} style={{ marginTop: "60px" }}>
              <h2 className={styles.bold}>{t("otherExamples")}</h2>
              <br />
              <div className={styles.Preview_screen3}>
                <Image
                  width={916}
                  height={308}
                  src="/img/apps/billy/screens/billy_react_3.png"
                  alt="happy Birthday preview formatted"
                  style={{ height: "auto" }}
                />
              </div>
              <div className={styles.Preview_screen}>
                <Image
                  width={796}
                  height={400}
                  src="/img/apps/billy/screens/birthday_react.png"
                  alt="happy Birthday preview"
                  style={{ height: "auto" }}
                />
              </div>
            </div>
            <br />
            <br />
            <br />
            <ReadyForBilly app={app} />
            <br />
            <br />
            <br />
            <Features app={app} />
          </div>
        </main>
        <Footer app={app} />
      </div>
    </>
  );
}
